import { store } from "../app/store";

const normalizeText = (value) => String(value ?? "").trim();

const getCurrentUserEncompassUser = () =>
	normalizeText(store.getState()?.auth?.userDetails?.encompass_user ?? "");

export const documentTrackerUploadedByCache = new Map();
export const documentTrackerUploadedByRequestCache = new Map();

export const getDocumentTrackerUploadedByDocumentId = (record = {}) =>
	normalizeText(record?.document_id ?? record?.entityId ?? record?.id ?? "");

export const shouldResolveDocumentTrackerUploadedBy = (record = {}) => {
	const createdBy = record?.createdBy ?? {};
	const createdByIdentifier = createdBy?.entityId ?? "";
	return createdByIdentifier === getCurrentUserEncompassUser();
};

export const getDocumentTrackerUploadedByFallbackText = (record = {}) => {
	if (record?.__isPendingRetryRecord) {
		return normalizeText(record?.uploadedBy ?? "");
	}

	return shouldResolveDocumentTrackerUploadedBy(record)
		? "Uploaded by Logan Connect User"
		: // The Encompass user is used as the EntityId, but there is no corresponding
			// record in loan_document_user_email for the configured Encompass users. (DEV_ENCOMPASS_USER / UAT_ENCOMPASS_USER / PROD_ENCOMPASS_USER).
			// In this case, the document was uploaded by Logan.
			"Uploaded by Logan";
	// The EntityId does not match any configured Encompass user. (DEV_ENCOMPASS_USER / UAT_ENCOMPASS_USER / PROD_ENCOMPASS_USER).
	//  This may occur for older loans or documents uploaded directly from Encompass.
};

export const getDocumentTrackerUploadedByDisplayText = (record = {}) => {
	if (record?.__isPendingRetryRecord) {
		return normalizeText(record?.uploadedBy ?? "");
	}

	const fallbackText = getDocumentTrackerUploadedByFallbackText(record);

	if (!shouldResolveDocumentTrackerUploadedBy(record)) {
		return fallbackText;
	}

	const documentId = getDocumentTrackerUploadedByDocumentId(record);

	if (!documentId) {
		return fallbackText;
	}

	const cachedEmail = documentTrackerUploadedByCache.get(documentId);

	return cachedEmail || fallbackText;
};

const getDocumentTrackerUploadedByEmail = (record = {}) =>
	normalizeText(
		record?.user_email ??
			record?.user_ae_email ??
			record?.email ??
			record?.data?.user_email ??
			record?.data?.user_ae_email ??
			record?.data?.email ??
			record?.response?.user_email ??
			record?.response?.user_ae_email ??
			record?.response?.email ??
			""
	);

const getContainerRecords = (value) => {
	if (Array.isArray(value)) {
		return value;
	}

	if (!value || typeof value !== "object") {
		return [];
	}

	return [
		value,
		value?.response,
		value?.data,
		value?.records,
		value?.items,
		value?.results,
	].filter(Boolean);
};

export const findDocumentTrackerUploadedByRecord = (payload, documentId) => {
	const normalizedDocumentId = normalizeText(documentId);

	if (!normalizedDocumentId) {
		return null;
	}

	const queue = [...getContainerRecords(payload)];
	const seen = new Set();

	while (queue.length > 0) {
		const current = queue.shift();

		if (!current || typeof current !== "object" || seen.has(current)) {
			continue;
		}

		seen.add(current);

		if (
			getDocumentTrackerUploadedByDocumentId(current) === normalizedDocumentId
		) {
			return current;
		}

		queue.push(...getContainerRecords(current));
	}

	return null;
};

export const getDocumentTrackerUploadedByEmailFromResponse = (
	payload,
	documentId
) => {
	const matchingRecord = findDocumentTrackerUploadedByRecord(
		payload,
		documentId
	);

	if (!matchingRecord) {
		return "";
	}

	return getDocumentTrackerUploadedByEmail(matchingRecord);
};
